import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";

const AvailableToStartModal = ({
  show,
  onHide,
  value,
  onSave,
  isApplyPage = false,
  shouldUpdateProfile = false,
}) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const [selectedOption, setSelectedOption] = useState("");
  const [error, setError] = useState("");

  const startOptions = [
    { value: "Immediately", label: "Immediately" },
    { value: "Within 2 weeks", label: "Within 2 weeks" },
    { value: "Within 30 days", label: "Within 30 days" },
    { value: "Within 60 days", label: "Within 60 days" },
    { value: "Just exploring", label: "Just exploring" },
  ];
  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  // Load existing value
  // useEffect(() => {
  //   if (!show) return;

  //   const current = store?.profileItem?.data?.nurseProfile?.available_to_start;

  //   if (current) {
  //     setSelectedOption(current);
  //   }
  // }, [show, store?.profileItem]);
  useEffect(() => {
    if (!show) return;

    if (isApplyPage) {
      setSelectedOption(value || "");
    } else {
      const current =
        store?.profileItem?.data?.nurseProfile?.available_to_start;
      setSelectedOption(current || "");
    }
  }, [show, value, isApplyPage, store]);
  const handleSelect = (value) => {
    setSelectedOption(value);
    setError("");
  };

  const handleSave = () => {
    if (!selectedOption) {
      setError("Please select your availability");
      return;
    }

    if (isApplyPage) {
      // ✅ ALWAYS update local
      onSave(selectedOption);

      // 🔥 ONLY call API if empty before
      if (shouldUpdateProfile) {
        const formData = new FormData();

        formData.append(
          "name",
          store?.profileItem?.data?.name ||
            store?.profileItem?.data?.full_name ||
            "",
        );

        formData.append("available_to_start", selectedOption);

        dispatch(updateProfile(formData));
      }

      onHide();
    } else {
      // ✅ Profile page → always API
      const formData = new FormData();

      formData.append(
        "name",
        store?.profileItem?.data?.name ||
          store?.profileItem?.data?.full_name ||
          "",
      );

      formData.append("available_to_start", selectedOption);

      dispatch(updateProfile(formData));
    }
  };
  // const handleSave = () => {
  //   if (!selectedOption) {
  //     setError("Please select your availability");
  //     return;
  //   }

  //   if (isApplyPage) {
  //     // ✅ LOCAL UPDATE
  //     onSave(selectedOption);
  //     onHide();
  //   } else {
  //     // ✅ API CALL (Profile page)
  //     const formData = new FormData();

  //     formData.append(
  //       "name",
  //       store?.profileItem?.data?.name ||
  //         store?.profileItem?.data?.full_name ||
  //         "",
  //     );

  //     formData.append("available_to_start", selectedOption);

  //     dispatch(updateProfile(formData));
  //   }
  // };
  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">
          When are you available to start a new position?
        </h5>

        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="radio-options">
          <div className="row">
            {startOptions.map((option) => (
              <div
                key={option.value}
                className={`radio-option col-lg-6 ${
                  selectedOption === option.value ? "selected" : ""
                }`}
                onClick={() => handleSelect(option.value)}
              >
                <div className="contentwrap">
                  <input
                    type="radio"
                    checked={selectedOption === option.value}
                    readOnly
                  />

                  <label className="radio-label">{option.label}</label>
                </div>
              </div>
            ))}
          </div>
        </div>

        {error && <div className="error-message mt-2">{error}</div>}

        <div className="text-center mt-4">
          <Button
            className="btn-primary px-4"
            onClick={handleSave}
            disabled={store?.isLoading || !selectedOption}
          >
            {store?.isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AvailableToStartModal;
